<section
  class="tw-relative tw-flex tw-flex-col tw-gap-6 tw-px-6 tw-py-8 tw-w-full tw-min-w-[300px] tw-mx-auto"
  [ngClass]="cornerClass()"
  [class.tw-bg-white]="isCompleted()"
  [class.tw-bg-gradient-followup-sheet]="!isCompleted()">

  @if (showLoader()) {
    <div class="tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-min-h-[400px]">
      <span class="tw-text-sm tw-text-gray-500" i18n="@@followUpSheetLoading">Loading…</span>
      <app-linear-loader-bar></app-linear-loader-bar>
    </div>
  } @else if (isCompleted()) {
    <div class="tw-flex tw-flex-col tw-gap-4 tw-w-full">
      <div class="tw-flex tw-items-center tw-gap-2">
        <div class="tw-w-5 tw-h-5 tw-rounded-full tw-bg-teal-400 tw-flex tw-items-center tw-justify-center tw-shrink-0">
          <em class="cs-icon-tick tw-text-white tw-text-[12px]"></em>
        </div>
        <p class="tw-font-lexend tw-font-bold tw-text-[18px] tw-leading-[22px] tw-text-gray-800 tw-m-0" i18n="@@followUpSheetCheckupCompletedTitle">
          Check-up completed successfully!
        </p>
      </div>
      @if (showCompletionBanner()) {
        <report-getting-ready margin="0"></report-getting-ready>
      }
      @if (showCompletionCta()) {
        <button
          type="button"
          class="tw-w-full tw-h-12 tw-rounded-3 tw-bg-teal-600 tw-text-white tw-font-lexend tw-font-semibold tw-text-[18px] tw-leading-[23.4px] tw-text-center tw-border-0 tw-cursor-pointer"
          (click)="acknowledgeCompletion()">
          <span i18n="@@okayCaps">Okay</span>!
        </button>
      }
    </div>
  } @else if (markingReady()) {
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-min-h-[400px]">
      <span class="tw-text-sm tw-text-gray-500" i18n="@@followUpSheetPreparingReport">Preparing your report…</span>
    </div>
  } @else {
    @if (questionNumber() === 1) {
      <header class="tw-flex tw-items-center tw-gap-3 tw-w-full">
        <div class="tw-shrink-0 tw-w-[72px] tw-h-[72px] tw-rounded-full tw-border-2 tw-border-white tw-overflow-hidden tw-bg-teal-100">
          @if (userImageUrl()) {
            <img [src]="userImageUrl()" class="tw-w-full tw-h-full tw-object-cover" alt=""/>
          }
        </div>
        <p class="tw-font-lexend tw-font-bold tw-text-[18px] tw-leading-[22px] tw-text-gray-800 tw-m-0" i18n="@@followUpSheetHeaderTitle">
          Ans a few questions, doctor will check your progress
        </p>
      </header>
    }

    <section class="tw-flex tw-flex-col tw-gap-5 tw-w-full">
      <div class="tw-flex tw-flex-col tw-gap-1.5">
        <div class="tw-flex tw-items-end tw-gap-1 tw-text-200 tw-leading-[17px]">
          <span class="tw-text-gray-400">Q{{ questionNumber() }}.</span>
          <span class="tw-text-gray-800 tw-font-lexend">{{ topicLabel() }}</span>
        </div>
        <div [@stepperFill]="filledSlots()" class="tw-flex tw-items-center tw-gap-1.5 tw-w-full">
          @for (slot of slotArray(); track $index; let i = $index) {
            <span class="tw-h-1 tw-rounded-[10px] tw-flex-1 tw-bg-white tw-overflow-hidden">
              @if (i < filledSlots()) {
                <span class="tw-block tw-h-full tw-w-full tw-bg-teal-400 tw-origin-left"></span>
              }
            </span>
          }
        </div>
      </div>

      @if (questionText()) {
        <div class="tw-flex tw-flex-col tw-gap-3">
          <p class="tw-text-base tw-font-body tw-leading-[20.8px] tw-text-gray-800 tw-m-0" [innerHTML]="richText(questionText())"></p>

          <div class="tw-flex tw-flex-col tw-gap-2 tw-w-full">
            @for (option of options(); track option.value || option.text || $index; let i = $index) {
              <button
                type="button"
                class="tw-w-full tw-rounded-lg tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-text-center tw-shadow-[0px_2px_4px_rgba(0,0,0,0.1)] tw-cursor-pointer tw-transition-colors tw-duration-200"
                [ngClass]="selectedOptionIndex() === i
                  ? 'tw-bg-teal-600 tw-text-white tw-border-0'
                  : 'tw-bg-white tw-text-teal-600 tw-border tw-border-teal-600'"
                [disabled]="inputsDisabled()"
                (click)="selectOption(option, i)"
                [innerHTML]="richText(option.text)">
              </button>
            }
          </div>
        </div>
      } @else if (botReplyInProcess()) {
        <div class="tw-flex tw-items-center tw-justify-center tw-min-h-[200px]">
          <span class="tw-text-sm tw-text-gray-500" i18n="@@followUpSheetWaiting">Loading next question…</span>
        </div>
      }

      @if (errorMessage()) {
        <div class="tw-text-sm tw-text-red-600">
          {{ errorMessage() }}
        </div>
      }
    </section>
  }
</section>
